import {rule} from '@/util/validateRules'

export const tableOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	menuAlign: 'center',
	searchMenuSpan: 6,
	editBtn: false,
	delBtn: false,
	align: 'center',
	addBtn: false,
	excelBtn: true,
	labelWidth: 130,
	column: [
		{
			fixed: true,
			label: 'id',
			prop: 'id',
			span: 24,
			hide: true,
			editDisplay: false,
			addDisplay: false,
		},
		{
			fixed: true,
			label: '姓名',
			prop: 'userName',
			slot: true,
			search: true,
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入内勤人员姓名',
				},
				{
					validator: rule.checkSpaceAll,
					trigger: 'blur',
				},
				{
					min: 2,
					max: 10,
					message: '长度在 2 到 10 个字符',
					trigger: 'blur',
				},
			],
		},
		{
			label: '登录密码',
			prop: 'password',
			span: 12,
			type: 'password',
			autocomplete: 'new-password',
			addDisabled: false,
			editDisabled: false,
			hide: true,
			rules: [
				{
					required: true,
					validator: rule.validatorPass,
					trigger: 'blur',
				},
			],
		},

		{
			label: '管理全部数据',
			prop: 'manageAll',
			type: 'select',
			rules: [
				{
					required: true,
					message: '请选择是否可以管理全部数据',
					trigger: 'blur',
				},
			],
			dicData: [
				{
					label: '否',
					value: 0,
				},
				{
					label: '是',
					value: 1,
				},
			],
		},
		{
			fixed: true,
			label: '登录名',
			prop: 'loginName',
			editDisabled: false,
			slot: true,
			search: true,
			rules: [
				{
					required: true,
					message: '请输入登录名',
				},
				{
					min: 4,
					max: 20,
					message: '长度在 4 到 20 个字符',
					trigger: 'blur',
				},
				{
					validator: rule.validatorUserName,
					trigger: 'blur',
				},
				{
					validator: rule.validHasBeenPresence,
					trigger: 'blur',
				},
			],
		},
		{
			label: '手机号',
			prop: 'mobile',
			value: '',
			search: true,
			span: 12,
			rules: [
				{
					min: 11,
					max: 11,
					message: '请输入正确的手机号码',
					trigger: 'blur',
				},
				{
					validator: rule.validatorMobile,
					trigger: 'blur',
				},
				{
					validator: rule.validHasBeenPresence,
					trigger: 'blur',
				},
			],
		},

		{
			label: '修改密码',
			type: 'switch',
			prop: 'changepassword',
			slot: false,
			border: false,
			hide: true,
			editDisplay: true,
			addDisplay: false,
			span: 12,
			value: 0,
			dicData: [
				{
					label: '否',
					value: 0,
				},
				{
					label: '是',
					value: 1,
				},
			],
		},
		{
			label: '角色',
			prop: 'role',
			value: 6,
			hide: true,
			editDisplay: false,
			addDisplay: false,
		},
		{
			label: '状态',
			prop: 'status',
			type: 'switch',
			slot: false,
			border: false,
			search: true,
			span: 12,
			value: 1,
			dicData: [
				{
					label: '停用',
					value: 0,
				},
				{
					label: '启用',
					value: 1,
				},
			],
		},
		{
			label: '存量保单维护',
			prop: 'adminFlag',
			type: 'switch',
			hide: true,
			showColumn: false,
			addDisplay: false,
			editDisplay: false,
			slot: false,
			border: false,
			search: false,
			span: 8,
			value: 0,
			dicData: [
				{
					label: '关闭',
					value: '0',
				},
				{
					label: '开启',
					value: '1',
				},
			],
		},
		{
			width: 180,
			label: '创建时间',
			prop: 'createdAt',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			editDisplay: false,
			addDisplay: false,
			span: 24,
		},
	],
}
